import { useApp } from '../App';
import { useState, useRef, useEffect } from 'react';
import api from '../api';
import VoiceButton from '../components/VoiceButton';
import { useI18n } from '../i18n/index.jsx';

export default function AiChat({ mode }) {
  const { user } = useApp();
  const { t } = useI18n();
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [sessionId, setSessionId] = useState(null);
  const bottom = useRef(null);

  useEffect(() => { bottom.current?.scrollIntoView({ behavior: 'smooth' }); }, [messages]);

  const titles = { lawyer: '⚖️ AI Юрист', accountant: '🧮 AI Бухгалтер', sales: '💼 AI Менеджер' };
  const title = titles[mode] || '🤖 AI';

  async function send(text) {
    const msg = text || input.trim();
    if (!msg || loading) return;
    setInput('');
    setMessages(m => [...m, { role: 'user', text: msg }]);
    setLoading(true);
    try {
      const { data } = await api.post(`/ai/${mode}/chat`, { message: msg, session_id: sessionId, mode });
      setSessionId(data.session_id);
      setMessages(m => [...m, { role: 'assistant', text: data.reply }]);
    } catch (e) {
      const errMsg = e.response?.data?.detail || e.message;
      if (errMsg.includes('API key') || errMsg.includes('not configured')) {
        setMessages(m => [...m, { role: 'assistant', text: '⚠️ AI временно недоступен. Попробуйте позже или обратитесь к администратору.' }]);
      } else {
        setMessages(m => [...m, { role: 'assistant', text: '❌ ' + errMsg }]);
      }
    }
    setLoading(false);
  }

  function handleVoice(text, error) {
    if (error) {
      setMessages(m => [...m, { role: 'assistant', text: '❌ ' + error }]);
      return;
    }
    if (text) send(text);
  }

  async function playTTS(text) {
    try {
      const response = await api.post('/voice/tts', { text, voice: 'nova' }, { responseType: 'blob', timeout: 30000 });
      const url = URL.createObjectURL(response.data);
      const audio = new Audio(url);
      audio.play();
    } catch {}
  }

  return (
    <div className="page chat-page">
      <h1>{title}</h1>
      <div className="chat-messages">
        {messages.length === 0 && (
          <div className="chat-empty">
            🎙️ Говорите или печатайте
            <br />
            {mode === 'lawyer'
              ? 'Трудовое право, визы, карты побыту...'
              : 'Налоги, ZUS, PIT, VAT, фактуры...'}
          </div>
        )}
        {messages.map((m, i) => (
          <div key={i} className={`chat-msg chat-${m.role}`}>
            <div className="chat-bubble">
              {m.text}
              {m.role === 'assistant' && !m.text.startsWith('❌') && !m.text.startsWith('⚠️') && (
                <button onClick={() => playTTS(m.text)}
                  style={{ background: 'none', border: 'none', cursor: 'pointer', marginLeft: 8, fontSize: 16, opacity: 0.6 }}>
                  🔊
                </button>
              )}
            </div>
          </div>
        ))}
        {loading && <div className="chat-msg chat-assistant"><div className="chat-bubble typing">...</div></div>}
        <div ref={bottom} />
      </div>
      <div className="chat-input">
        <VoiceButton onResult={handleVoice} style={{ width: 40, height: 40, borderRadius: '50%', padding: 0 }} />
        <input value={input} onChange={e => setInput(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && send()} placeholder="Введите вопрос..." style={{ flex: 1 }} />
        <button onClick={() => send()} disabled={loading}>📤</button>
      </div>
    </div>
  );
}
